import { Provider } from '@angular/core';
import {
  NOTIFICATIONS_STORE,
  resolveNotificationsStoreMode
} from './notifications-store.interface';
import { NotificationsMockStore } from './notifications-mock-store.service';
import { NotificationsFirestoreStore } from './notifications-firestore-store.service';

export function provideNotificationsStore(): Provider[] {
  return [
    NotificationsMockStore,
    NotificationsFirestoreStore,
    {
      provide: NOTIFICATIONS_STORE,
      useFactory: (mock: NotificationsMockStore, firestore: NotificationsFirestoreStore) =>
        resolveNotificationsStoreMode() === 'mock' ? mock : firestore,
      deps: [NotificationsMockStore, NotificationsFirestoreStore]
    }
  ];
}
